export function setPageMeta() {
  if (typeof document === 'undefined') return

  // Browser tab title
  document.title = 'El Método Hogar Dorado | Gana $500 Extra desde Casa'

  const metaTags: Record<string, string> = {
    // Standard
    description:
      'Aprende a ganar tus primeros $500 extras usando solo tu WhatsApp. Sin tecnología complicada. Para mujeres latinas en EE.UU.',
    // Open Graph (Facebook, WhatsApp, LinkedIn)
    'og:type': 'website',
    'og:title': 'El Método Hogar Dorado 🌟 Gana $500 Extra desde Casa',
    'og:description':
      'Convierte tu talento en dinero real. Guía paso a paso para mujeres latinas. Acceso inmediato por solo $6.36.',
    'og:image':
      'https://cdn.magicpatterns.com/uploads/jQ1hNyGeqQXZoZGEs3CG5K/heylloyd-image-1771650313549.png',
    'og:image:width': '1200',
    'og:image:height': '630',
    // Twitter / X
    'twitter:card': 'summary_large_image',
    'twitter:title': 'El Método Hogar Dorado 🌟 Gana $500 Extra desde Casa',
    'twitter:description':
      'Convierte tu talento en dinero real. Guía paso a paso para mujeres latinas. Acceso inmediato por solo $6.36.',
    'twitter:image':
      'https://cdn.magicpatterns.com/uploads/jQ1hNyGeqQXZoZGEs3CG5K/heylloyd-image-1771650313549.png',
  }

  Object.entries(metaTags).forEach(([key, content]) => {
    // Determine attribute name (property for og:, name for everything else)
    const isProperty = key.startsWith('og:')
    const attrName = isProperty ? 'property' : 'name'

    // Check if tag already exists
    let tag = document.querySelector(
      `meta[${attrName}="${key}"]`,
    ) as HTMLMetaElement | null

    if (!tag) {
      tag = document.createElement('meta')
      tag.setAttribute(attrName, key)
      document.head.appendChild(tag)
    }

    tag.setAttribute('content', content)
  })
}
